:host {
  /*
  We want our badge to have a round shape when it has only 1 character in it, but we also want it to deform to oval shapes when it has lots of text in it. This can be difficult to achieve when a single character may be slender (ex. the number "1") or wide (ex. the letter "W").

  Now that 'lh' is supported, we can use it to set the min-size of the badge to be the same as the line-height of the surrounding text.
  */
  --aha-badge--min-size: 1.25em;
  --aha-badge--vertical-padding: unset;
  --aha-badge--horizontal-padding: 1ch;
  --aha-badge--color: ;
  --aha-badge--background: ;
  --aha-badge--text-opacity: 1;
  --aha-badge--font-size: 75%;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;

  min-width: var(--aha-badge--min-size);
  min-height: var(--aha-badge--min-size);
  box-sizing: border-box;
  border-radius: var(--aha-badge--min-size);
  color: var(--aha-badge--color);
  background: var(--aha-badge--background);
}

:host([size='text-based']) {
  --aha-badge--font-size: 75%;
  --aha-badge--horizontal-padding: 1ch;
}

:host([size='medium']) {
  --aha-badge--font-size: 12px;
  --aha-badge--horizontal-padding: 10px;
  --aha-badge--vertical-padding: 3px;
}

:host(:not([flavor])),
:host([flavor='blue']) {
  --aha-badge--color: var(--theme-light-blue-500-dark-blue-100);
  --aha-badge--background: var(--theme-light-blue-100-dark-blue-500);
}
:host([flavor='red']) {
  --aha-badge--color: var(--theme-light-red-800-dark-red-100);
  --aha-badge--background: var(--theme-light-red-100-dark-red-800);
}
:host([flavor='yellow']) {
  --aha-badge--color: var(--theme-light-yellow-800-dark-yellow-100);
  --aha-badge--background: var(--theme-light-yellow-100-dark-yellow-800);
}
:host([flavor='green']) {
  --aha-badge--color: var(--theme-light-green-800-dark-green-100);
  --aha-badge--background: var(--theme-light-green-100-dark-green-800);
}
:host([flavor='gray']) {
  --aha-badge--color: var(--theme-light-gray-800-dark-gray-100);
  --aha-badge--background: var(--theme-light-gray-200-dark-gray-700);
}
:host([flavor='orange']) {
  --aha-badge--color: var(--theme-light-orange-800-dark-orange-200);
  --aha-badge--background: var(--theme-light-orange-200-dark-orange-700);
}
:host([flavor='white']) {
  --aha-badge--color: var(--theme-light-gray-800-dark-gray-100);
  --aha-badge--background: #fff;
}
:host([flavor='integration-error']) {
  --aha-badge--color: white;
  --aha-badge--background: var(--aha-red-800);
}
:host([flavor='integration-warning']) {
  --aha-badge--color: white;
  --aha-badge--background: var(--aha-orange-600);
}
:host([flavor='integration-info']) {
  --aha-badge--color: white;
  --aha-badge--background: var(--aha-teal-400);
}
:host([flavor='integration-debug']) {
  --aha-badge--color: white;
  --aha-badge--background: var(--aha-gray-700);
}

:host([invert]:not([flavor])),
:host([invert][flavor='blue']) {
  --aha-badge--color: var(--theme-light-blue-100-dark-blue-500);
  --aha-badge--background: var(--theme-light-blue-500-dark-blue-100);
}
:host([invert][flavor='red']) {
  --aha-badge--color: var(--theme-light-red-100-dark-red-800);
  --aha-badge--background: var(--theme-light-red-800-dark-red-100);
}
:host([invert][flavor='yellow']) {
  --aha-badge--color: var(--theme-light-yellow-100-dark-yellow-800);
  --aha-badge--background: var(--theme-light-yellow-800-dark-yellow-100);
}
:host([invert][flavor='green']) {
  --aha-badge--color: var(--theme-light-green-100-dark-green-800);
  --aha-badge--background: var(--theme-light-green800-dark-green-100);
}
:host([invert][flavor='gray']) {
  --aha-badge--color: var(--theme-light-gray-100-dark-gray-800);
  --aha-badge--background: var(--theme-light-gray-700-dark-gray-200);
}
:host([invert][flavor='orange']) {
  --aha-badge--color: var(--theme-light-orange-200-dark-orange-800);
  --aha-badge--background: var(--theme-light-orange-700-dark-orange-200);
}
:host([invert][flavor='white']) {
  --aha-badge--color: #fff;
  --aha-badge--background: var(--theme-light-gray-800-dark-gray-100);
}

div {
  line-height: normal;
  font-size: var(--aha-badge--font-size);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--aha-badge--vertical-padding) var(--aha-badge--horizontal-padding);
  opacity: var(--aha-badge--text-opacity);
}
